import { createStore } from 'vuex'

export default createStore({
  state: {
    username: '',
    isLoggedIn: false
  },
  
  mutations: {
    SET_USERNAME(state, username) {
      state.username = username;
      state.isLoggedIn = true;
    },
    LOGOUT(state) {
      state.username = '';
      state.isLoggedIn = false;
    }
  },
  
  actions: {
    loginUser({ commit }, username) {
      commit('SET_USERNAME', username);
      localStorage.setItem('username', username);
    },
    logoutUser({ commit }) {
      localStorage.removeItem('username');
      commit('LOGOUT');
    },
    initializeStore({ commit }) {
      const username = localStorage.getItem('username');
      if (username) {
        commit('SET_USERNAME', username);
      }
    }
  },
  
  getters: {
    currentUsername: state => state.username,
    isLoggedIn: state => state.isLoggedIn
  }
}) 